import React from 'react';
import { Button } from './ui/button';
export function BuyerRebate() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-55">
      <div className="container mx-auto px-4 md:px-6" data-id="element-56">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-57">
          {/* Image Column */}
          <div className="relative" data-id="element-58">
            <div className="aspect-[4/3] md:aspect-video lg:aspect-[4/3] overflow-hidden rounded-sm" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/6bFG424KRniqEYe6TvQe3b/mesa-hero-one-percent-az.webp" alt="Arizona red rock landscape with homes" className="w-full h-full object-cover" data-id="element-60" />
            </div>
          </div>

          {/* Content Column */}
          <div data-id="element-61">
            <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-62">
              For Buyers Too
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight mb-6" data-id="element-63">
              Buying a home in Arizona? Get cash back at closing.
            </h2>
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed" data-id="element-64">
              We don't just help sellers keep more of their equity. Qualified
              buyers working with One Percent Listing AZ can receive a rebate at
              closing. It's our way of sharing the savings.
            </p>
            <Button variant="outline" className="border-brick-red text-brick-red hover:bg-brick-red hover:text-white h-12 px-8 text-base w-full sm:w-auto" data-id="element-65">
              Learn About the Buyer Rebate
            </Button>
          </div>
        </div>
      </div>
    </section>;
}